module.exports = __webpack_public_path__ + "img/2_19.acc79734.png";